import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Alert,
  AlertTitle,
} from '@mui/material';
import { Error as ErrorIcon, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const WithdrawError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 3 }}>
        <Box sx={{ mb: 4 }}>
          <ErrorIcon sx={{ fontSize: 80, color: '#ef4444' }} />
        </Box>

        <Alert 
          severity="error" 
          sx={{ mb: 4, borderRadius: 2 }}
        >
          <AlertTitle>Withdrawal Failed</AlertTitle>
          TRANSACTION FAILED. CONTACT support@1sttrustfi.com FOR MORE DETAILS.
        </Alert>

        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          We apologize, but your withdrawal request could not be processed at this time.
          Please contact our support team for assistance with your transaction.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate('/dashboard')}
            size="large"
          >
            Back to Dashboard
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate('/dashboard')}
            size="large"
          >
            Try Again
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default WithdrawError;
